import { render } from "./ActivityBody.vue?vue&type=template&id=b8846568&scoped=true"
import script from "./ActivityBody.vue?vue&type=script&lang=js"
export * from "./ActivityBody.vue?vue&type=script&lang=js"

import "./ActivityBody.vue?vue&type=style&index=0&id=b8846568&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8846568"]])

export default __exports__